// Icon
import * as React from 'react';
export default function Icon(props) {
  return /*#__PURE__*/React.createElement("i", {
    className: "rmel-iconfont rmel-icon-" + props.type
  });
}